import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { NotyService } from './noty.service';

declare var window: any;

@Injectable({
  providedIn: 'root',
})
export class BrowserNotificationService {
  /**
   * Indicates if the user has granted permission for notification
   * @type {boolean}
   */
  public notificationPermissionGranted: boolean = true;

  /**
   * Indicates if a Notification request has been denied
   * @type {boolean}
   */
  public notificationRequestDenied: boolean = false;

  /**
   * Instructions to show in alert and in user edit page on notification request denied
   * @type {string}
   */
  public instructionsOnPermissionDenied: string = 'If you have already denied permission once in the past, permission may need a check by clicking on the lock icon on the address bar and enabling permission for notification there.';

  /**
   * Constructor
   * @param {NotyService} private notyService Shpw notifications
   * @param {Router}      private router      Angular router for navigation
   */
  constructor(private notyService: NotyService, private router: Router) {
    this.setNotificationPermissionGranted();
  }

  /**
   * Request for Notification permission from user
   */
  requestNofiticationPermission() {
    if (!window.Notification) this.notyService.notify('This browser does not support notifications', 'error', 5000, 'topCenter');
    else {
      this.setNotificationPermissionGranted();
      if (!this.notificationPermissionGranted) {
        let scope: BrowserNotificationService = this;
        window.Notification.requestPermission().then((result: string) => {
          if (result == 'granted') {
            this.notificationPermissionGranted = true;
            this.notificationRequestDenied = false;
            this.notyService.notify('Notification Permission Received', 'success', 5000, 'topCenter');
          } else {
            this.notificationPermissionGranted = false;
            this.notificationRequestDenied = true;
            this.notyService.notify(`Notification Permission Denied - ${this.instructionsOnPermissionDenied}`, 'error', 5000, 'topCenter');
          }
        });
      }
    }
  }

  /**
   * Set current notification permission status
   */
  setNotificationPermissionGranted() {
    this.notificationPermissionGranted = window.Notification && window.Notification.permission == 'granted';
  }

  /**
   * Show a browser notification
   */
  showNotification(title: string, options: any = {}) {
    if (!window.Notification) {
      console.log('Received browser notification from server. This browser does not support browser notifications.');
    } else {
      this.requestNofiticationPermission();
      let notification: any = new window.Notification(title, options);
      let scope: BrowserNotificationService = this;
      if (options.data && options.data.url)
        notification.onclick = (event: any) => {
          if (event.target && event.target.data && event.target.data.url) {
            window.open(window.location.origin + '/' + event.target.data.url).focus();
            //scope.router.navigateByUrl(event.target.data.url);
            //window.focus();
            event.target.close();
          }
        };
    }
  }
}
